var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.classes,on:{"mouseenter":function($event){_vm.expand = true},"mouseleave":function($event){_vm.mode === 'hidden' ? _vm.expand = false: null}}},[_c('router-link',{staticClass:"indicate-text",class:!_vm.expand && 'fas fa-sign-out-alt',attrs:{"to":_vm.to}},[_vm._v(" "+_vm._s(_vm.expand ? _vm.label : '')+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }